/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { UsersState } from '@app/user/store/users.state';
import { createFeatureSelector, createSelector } from '@ngrx/store';

const selectUsersState = createFeatureSelector<UsersState>('users');

export const getUsers = createSelector(selectUsersState, state => state.users);
export const getIsUserActionPending = createSelector(selectUsersState, state => state.isActionPending);
export const getCurrentUser = createSelector(selectUsersState, state => state.currentUser);
export const isActionPending = createSelector(selectUsersState, state => state.isActionPending);
export const getUserPersistViolations = createSelector(selectUsersState, state => state.persistViolations);
